import "./_styleGuide.scss";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import React, { useState } from "react";
import { Button, TextField } from "@mui/material";
import { ThemeProvider } from "@mui/material";
import {
  redTheme,
  blueTheme,
  greyTheme,
  greenTheme,
  disabledPrimary,
  disabledSecondary,
} from "../../constants/Theme";
import LoadingButton from "@mui/lab/LoadingButton";
import { SnackbarProvider, VariantType, useSnackbar } from "notistack";

function EnqueSnackBar() {
  const { enqueueSnackbar } = useSnackbar();

  const handleClickVariant = (variant: VariantType, msg: string) => () => {
    // variant could be success, error, warning, info, or default
    enqueueSnackbar(msg, { variant });
  };

  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <ThemeProvider theme={greenTheme}>
          <Grid item xs={12} sm={3}>
            <Button id="3372d2a9-c6f1-4717-b0da-b568fce09ed0"
              color="primary"
              variant="contained"
              onClick={handleClickVariant(
                "success",
                " This is success message."
              )}
            >
              Success
            </Button>
          </Grid>
        </ThemeProvider>
        <ThemeProvider theme={redTheme}>
          <Grid item xs={12} sm={3}>
            <Button id="75a847f9-38b7-45d4-be4d-ef8520cfdcdc"
              color="primary"
              variant="contained"
              onClick={handleClickVariant(
                "error",
                " This is an error message."
              )}
            >
              Error
            </Button>
          </Grid>
        </ThemeProvider>
        <Grid item xs={12} sm={3}>
          <Button id="f6c64751-f92a-4874-acc1-87de98d56db9"
            variant="contained"
            sx={{ backgroundColor: "orange" }}
            onClick={handleClickVariant("warning", "This is a warning.")}
          >
            Warning
          </Button>
        </Grid>
        <ThemeProvider theme={blueTheme}>
          <Grid item xs={12} sm={3}>
            <Button id="5fac4f99-7c43-4ce2-8fba-a183a71721d8"
              color="primary"
              variant="contained"
              onClick={handleClickVariant("info", "This is an info message.")}
            >
              Information
            </Button>
          </Grid>
        </ThemeProvider>
      </Grid>
    </React.Fragment>
  );
}

export default function BackGroundColor() {
  //LoadingButton
  const [loading, setLoading] = useState(false);
  function loadingBtnClick() {
    if (loading) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }

  return (
    <React.Fragment>
      <Container maxWidth="lg">
        <h1>UDL Digital Styleguide</h1>
        <hr />
        <h2>Typography</h2>
        <br />
        <br />
        <div>
          <p className="small">Headings</p>
          <h1>Heading 1</h1>
          <h2>Heading 2</h2>
          <h3>Heading 3</h3>
          <p className="small">Base</p>
          <p>
            Regular
            <br />
            <em>Italic</em>
            <br />
            <strong>Bold</strong>
            <br />
            <a href="https://www.riotinto.com.au/">Hyperlink</a>
            <br />
            <span>Inline icon</span>
            <i className="c-Icon__icon icon material left md-24">home</i>
          </p>
          <Grid container>
            <Grid item xs={4}>
              <p className="small">Paragraph (small)</p>
              <p className="small">
                The IDP connects to globally distributed Rio Tinto data sources
                and regularly extracts data, storing it in the catalogue.
              </p>
            </Grid>
            <Grid item xs={4}>
              <p className="small">Paragraph (regular)</p>
              <p className="normal">
                The IDP connects to globally distributed Rio Tinto data sources
                and regularly extracts data, storing it in the catalogue.
              </p>
            </Grid>
            <Grid item xs={4}>
              <p>Paragraph (large)</p>
              <p className="lead">
                The IDP connects to globally distributed Rio Tinto data sources
                and regularly extracts data, storing it in the catalogue.
              </p>
            </Grid>
          </Grid>
        </div>
        <br /> <br />
        <hr />
        <h2>Colors</h2>
        <br />
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <Box className="BlackBoxStyle">black #1D1D1B</Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box className="OffWhiteBoxStyle">offWhite #F5F5F5</Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box className="MidWhiteBoxStyle">midWhite #DDDDDD</Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box className="LightGreyBoxStyle">lightgrey #B2B2B2</Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box className="GreyBoxStyle">grey #706F6F</Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box className="RedBoxStyle">red #E60D2E</Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box className="DarkRedBoxStyle">darkRed #8B0D19</Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box className="GreenBoxStyle">green #84BD00</Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box className="BlueBoxStyle">blue #005EB8</Box>
          </Grid>
        </Grid>
        <br /> <br />
        <hr />
        <h2>Forms</h2>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <p> Button </p>
            <ThemeProvider theme={greyTheme}>
              <Button id="f2d8f544-211e-450b-8d75-d81a7b4906c9" color="primary" variant="contained">
                Add Source
              </Button>
            </ThemeProvider>
          </Grid>
          <Grid item xs={3}>
            <p> Button : hover </p>
            <ThemeProvider theme={greyTheme}>
              <Button id="c17451df-db36-4774-bbc4-65574a1326ff" color="primary" variant="contained">
                Add Source
              </Button>
            </ThemeProvider>
          </Grid>
          <Grid item xs={3}>
            <p> Button : disabled </p>
            <ThemeProvider theme={greyTheme}>
              <Button id="8bd34995-4370-4f24-a0e1-0d8a6a9bfd05" color="primary" disabled>
                Add Source
              </Button>
            </ThemeProvider>
          </Grid>
          <Grid item xs={3}>
            <p> Button loading </p>
            <ThemeProvider theme={greyTheme}>
              <LoadingButton
                onClick={loadingBtnClick}
                loading={loading}
                variant="contained"
              >
                Add Source
              </LoadingButton>
            </ThemeProvider>
          </Grid>
          <Grid item xs={12} sm={3}>
            <p> Button (primary)</p>
            <ThemeProvider theme={blueTheme}>
              <Button id="7d978529-136b-478d-be75-4957aab58010" color="primary" variant="contained">
                Add Source
              </Button>
            </ThemeProvider>
          </Grid>
          <Grid item xs={3}>
            <p> Button (primary) : hover </p>
            <ThemeProvider theme={blueTheme}>
              <Button id="b7487f2b-b8df-4e62-b3ac-4087a61ebe54" variant="contained" color="primary">
                Add Source
              </Button>
            </ThemeProvider>
          </Grid>
          <Grid item xs={3}>
            <p> Button (primary) : disabled </p>
            <ThemeProvider theme={disabledPrimary}>
              <Button id="f8ea8b76-53fe-4076-9c43-2f45a1af6a9e" variant="contained" color="primary" disabled>
                Add Source
              </Button>
            </ThemeProvider>
          </Grid>
          <Grid item xs={3}>
            <p> Button (primary) loading </p>
            <ThemeProvider theme={blueTheme}>
              <LoadingButton
                onClick={loadingBtnClick}
                loading={loading}
                variant="contained"
              >
                Add Source
              </LoadingButton>
            </ThemeProvider>
          </Grid>
          <Grid item xs={12} sm={3}>
            <p> Button (secondary)</p>
            <ThemeProvider theme={redTheme}>
              <Button id="99efe4a7-b0cd-40a6-84ce-ea4686e9dd83" variant="contained" color="primary">
                Add Source
              </Button>
            </ThemeProvider>
          </Grid>
          <Grid item xs={3}>
            <p> Button (secondary) : hover </p>
            <ThemeProvider theme={redTheme}>
              <Button id="9f4e0258-1998-4d43-a5b4-5d0a004a20f3" variant="contained" color="primary">
                Add Source
              </Button>
            </ThemeProvider>
          </Grid>
          <Grid item xs={3}>
            <p> Button (secondary) : disabled </p>
            <ThemeProvider theme={disabledSecondary}>
              <Button id="70101e57-5a98-4f1b-809d-a1317cf25f40" variant="contained" color="primary" disabled>
                Add Source
              </Button>
            </ThemeProvider>
          </Grid>
          <Grid item xs={3}>
            <p> Button (secondary) loading </p>
            <ThemeProvider theme={redTheme}>
              <LoadingButton
                onClick={loadingBtnClick}
                loading={loading}
                variant="contained"
              >
                Add Source
              </LoadingButton>
            </ThemeProvider>
          </Grid>
          <Grid item xs={3}>
            <p> Input (text)</p>
            <TextField id="Label" label="Placeholder" variant="outlined" />
          </Grid>
          <Grid item xs={3}>
            <p> Input (text) : disabled</p>
            <TextField
              disabled
              id="filled-disabled"
              defaultValue="Placeholder"
              variant="filled"
            />
          </Grid>
          <Grid item xs={3}>
            <p> Input (text) (info)</p>
            <TextField
              id="Label"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <p> Input (text) required</p>
            <TextField
              required
              id="outlined-required"
              label="Placeholder"
              defaultValue="Hello World"
            />
          </Grid>
          <Grid item xs={3}>
            <p> Input (text) (invalid)</p>
            <TextField
              error
              id="outlined-error"
              label="Error"
              defaultValue="Hello World"
            />
          </Grid>
        </Grid>
        <br />
        <br />
        <hr />
        <h2>Notifications</h2>
        <br />
        <SnackbarProvider
          anchorOrigin={{ horizontal: "right", vertical: "top" }}
          maxSnack={4}
        >
          <EnqueSnackBar />
        </SnackbarProvider>
        <br />
        <br />
        <br />
      </Container>
    </React.Fragment>
  );
}
